// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDsHrVntaO-mb-3zGA6r8-6L_-P4loY-dg",
    authDomain: "pobp-a7780.firebaseapp.com",
    databaseURL: "https://pobp-a7780-default-rtdb.firebaseio.com",
    projectId: "pobp-a7780",
    storageBucket: "pobp-a7780.appspot.com",
    messagingSenderId: "699809713598",
    appId: "1:699809713598:web:945ab4dbc9657b532ffdef",
    measurementId: "G-D0E046YR0V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider(); // Google provider
const db = getDatabase(app);

export { auth, googleProvider, db };
